import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { LogIn } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Inicio de sesión exitoso');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-offwhite px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full max-w-md"
      >
        <div className="bg-paper p-8 editorial-border">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold tracking-tight mb-2" data-testid="admin-login-title">
              Panel de Admin
            </h1>
            <p className="text-sm font-sans tracking-widest uppercase text-ink/60">Iniciar Sesión</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <label htmlFor="username" className="block text-sm font-sans tracking-widest uppercase text-ink/60 mb-2">
                Usuario
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                data-testid="admin-username-input"
                className="w-full px-4 py-3 border border-ink/20 focus:border-editorial focus:outline-none transition-colors"
                placeholder="admin"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-sans tracking-widest uppercase text-ink/60 mb-2">
                Contraseña
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                data-testid="admin-password-input"
                className="w-full px-4 py-3 border border-ink/20 focus:border-editorial focus:outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-ink text-paper py-4 text-sm font-sans tracking-widest uppercase hover:bg-editorial transition-colors duration-200 disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? 'Iniciando...' : 'Iniciar Sesión'}
              <LogIn className="w-4 h-4" />
            </button>
          </form>

          <p className="mt-6 text-sm font-sans text-ink/50 text-center">
            Por defecto: admin / admin123
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;